module.exports = __webpack_public_path__ + "img/emptyData.4bfe5253.png";